import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DutyHolderData, DutyHolderType } from "../../../Types/DutyHolderDetails/New/DutyHolderDetailsTypes";
import { fetchDutyHolderData, fetchDutyHolderTypes } from "../../../Thunks/DutyHolderDetailThunks";

interface DutyHolderDetailSlice {
    loadingDutyHolderTypes: boolean;
    dutyHolderTypes: DutyHolderType[];
    errorDutyHolderTypes: string | null;

    loadingDutyHolderData: boolean;
    dutyHolderData: DutyHolderData[];
    errorDutyHolderData: string | null;
}

// set initial values
const initialState: DutyHolderDetailSlice = {
    loadingDutyHolderTypes: false,
    dutyHolderTypes: [],
    errorDutyHolderTypes: null,

    loadingDutyHolderData: false,
    dutyHolderData: [],
    errorDutyHolderData: null,
};

// set state value for api response
const dutyHolderDetailSlice = createSlice({
    name: "dutyHolderDetail",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Duty holder types
            .addCase(fetchDutyHolderTypes.pending, (state) => {
                state.loadingDutyHolderTypes = true;
                state.errorDutyHolderTypes = null;
            })
            .addCase(fetchDutyHolderTypes.fulfilled, (state, action: PayloadAction<DutyHolderType[]>) => {
                state.loadingDutyHolderTypes = false;
                state.dutyHolderTypes = action.payload;
            })
            .addCase(fetchDutyHolderTypes.rejected, (state) => {
                state.loadingDutyHolderTypes = false;
                state.errorDutyHolderTypes = "Failed to fetch duty holder types";
            })

            // Duty holder data
            .addCase(fetchDutyHolderData.pending, (state) => {
                state.loadingDutyHolderData = true;
                state.errorDutyHolderData = null;
            })
            .addCase(fetchDutyHolderData.fulfilled, (state, action: PayloadAction<DutyHolderData[]>) => {
                state.loadingDutyHolderData = false;
                state.dutyHolderData = action.payload;
            })
            .addCase(fetchDutyHolderData.rejected, (state) => {
                state.loadingDutyHolderData = false;
                state.errorDutyHolderData = "Failed to fetch duty holder data";
            })
    },
});

export default dutyHolderDetailSlice.reducer;